import e from "./_arrayLikeKeys.js";
import a from "./_baseKeys.js";
import s from "./isArrayLike.js";
var i = e, y = a, k = s;
function m(r) {
  return k(r) ? i(r) : y(r);
}
var p = m;
export {
  p as default
};
//# sourceMappingURL=keys.js.map
